'use strict';

const heatMapFunctionality = () => {
	let map = null;
	const data = window.mapData;
	const mapSettings = {
		accessToken: 'pk.eyJ1IjoicmVkZWRnZS1pYW4iLCJhIjoiY2ltY2k0aTB5MDAwNnZnbTZ5MG00dTJ6eCJ9.FwrywaeB0MEJsONeF7Orjg',
		initialZoom: '3',
		maxZoom: '3'
	};

	const getDistricts = () => {
		return data.filter( point => point.properties.type === 'district' );
	};

	const mapInit = () => {
		if ( ! map ) {
			map = new mapboxgl.Map( {
				container: 'heatmap',
				style: 'mapbox://styles/mapbox/outdoors-v11',
				center: [ -100.35, 38.64 ],
				zoom: mapSettings.initialZoom,
				interactive: false
			} );

			map.scrollZoom.disable();
		}
	};

	const loadMap = () => {
		const districts = getDistricts();
		const id = 'districts';

		map.on( 'load', () => {
			map.addSource( 'states', {
				type: 'geojson',
				data: 'https://docs.mapbox.com/mapbox-gl-js/assets/us_states.geojson'
			} );

			map.addSource( id, {
				type: 'geojson',
				data: {
					type: 'FeatureCollection',
					features: districts
				}
			} );

			map.addLayer(
				{
					id,
					type: 'heatmap',
					source: id,
					maxzoom: 9,
					paint: {
						// Increase the heatmap weight based on frequency and property magnitude
						'heatmap-weight': [
							'interpolate',
							[ 'linear' ],
							[ 'get', 'mag' ],
							0,
							0,
							6,
							1
						],
						// Increase the heatmap color weight weight by zoom level
						// heatmap-intensity is a multiplier on top of heatmap-weight
						'heatmap-intensity': [
							'interpolate',
							[ 'linear' ],
							[ 'zoom' ],
							0,
							1,
							9,
							3
						],
						// Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
						// Begin color ramp at 0-stop with a 0-transparancy color
						// to create a blur-like effect.
						'heatmap-color': [
							'interpolate',
							[ 'linear' ],
							[ 'heatmap-density' ],
							0,
							'rgba(243,117,66,0)',
							0.2,
							'rgba(243,117,66,0.2)',
							0.4,
							'rgba(243,117,66,0.4)',
							0.6,
							'rgba(243,117,66,0.6)',
							0.8,
							'rgba(243,117,66,0.8)',
							1,
							'rgba(243,117,66,1)'
						],
						// Adjust the heatmap radius by zoom level
						'heatmap-radius': [
							'interpolate',
							[ 'linear' ],
							[ 'zoom' ],
							10, //0
							50, //2
							128, //9
							256 //20
						],
						// Transition from heatmap to circle layer by zoom level
						'heatmap-opacity': [
							'interpolate',
							[ 'linear' ],
							[ 'zoom' ],
							7,
							1,
							9,
							0
						]
					}
				},
				'waterway-label'
			);
		} );
	};

	return {
		init() {
			mapboxgl.accessToken = mapSettings.accessToken;
			mapInit();
			loadMap();
		}
	};
};

heatMapFunctionality().init();
